<div class="create-job-workspace">
  <form [formGroup]="createJobForm">
    <div class="stepper-header-section" *ngIf="currentStep < 3">
      <div class="header-title-section">
        <button type="button" class="back-nav-btn" (click)="navigateToJobsTab()" title="Back to Jobs">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
        </button>
        <div class="view-header-left">
          <h1 class="view-title">Create New Job</h1>
          <p class="view-subtitle">
            Fill in the details to post a new job opening
          </p>
        </div>
      </div>

      <!-- Multi-Step Pill Bar Indicator -->
      <div class="multi-step-pill-bar">
        <!-- Step 1 Indicator -->
        <div class="step-pill-item" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
          <span class="step-circle">
            <svg *ngIf="currentStep > 1" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            <span *ngIf="currentStep === 1">1</span>
          </span>
          <span class="step-lbl-text">Job Details</span>
        </div>

        <div class="step-pill-divider"></div>

        <!-- Step 2 Indicator -->
        <div class="step-pill-item" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
          <span class="step-circle">
            <svg *ngIf="currentStep > 2" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            <span *ngIf="currentStep <= 2">2</span>
          </span>
          <span class="step-lbl-text">Review & Submit</span>
        </div>
      </div>
    </div>

    <!-- STEP 1: FORM DETAILS VIEW -->
    <div class="step-content-panel fade-in-panel" *ngIf="currentStep === 1">
      <!-- Card 1: Basic Details -->
      <div class="form-block-card">
        <h3 class="card-section-heading">Basic Details</h3>

        <div class="form-row-2col">
          <div class="form-input-control">
            <label class="input-lbl-tag">Job Title *</label>
            <input type="text" placeholder="e.g. JEE Trainer" formControlName="job_title"
              class="standard-input-element" />
            <ng-container *ngIf="createJobForm.get('job_title')?.touched">
              <div class="text-danger smaller-text">
                <small class="text-danger smaller-text" *ngIf="createJobForm.get('job_title')?.errors?.['required']">
                  Job Title is required.
                </small>

                <small class="text-danger smaller-text" *ngIf="
                    createJobForm.get('job_title')?.errors?.['minlength'] ||
                    createJobForm.get('job_title')?.errors?.['maxlength']
                  ">
                  Job Title must be between 3 and 100 characters.
                </small>

                <small class="text-danger smaller-text" *ngIf="createJobForm.get('job_title')?.errors?.['pattern']">
                  Invalid Job Title format.
                </small>
              </div>
            </ng-container>
          </div>

          <div class="form-input-control">
            <label class="input-lbl-tag">Job Role Category *</label>
            <select formControlName="job_role_category" class="standard-select-element">
              <option value="" disabled selected>
                Select Job Role Category
              </option>
              <option *ngFor="let cat of categories" [value]="cat">
                {{ cat }}
              </option>
              <option value="Other">Other (Please specify)</option>
            </select>
            <small class="text-danger smaller-text" *ngIf="
                createJobForm.get('job_role_category')?.touched &&
                createJobForm.get('job_role_category')?.errors?.['required']
              ">
              Please select a Job Role Category.
            </small>

            <!-- Custom Category Input -->
            <div class="custom-category-input animate-fade-in mt-3"
              *ngIf="createJobForm.get('job_role_category')?.value === 'Other'">
              <input type="text" placeholder="Enter custom category" formControlName="custom_job_role_category"
                class="standard-input-element" (input)="onCustomCategoryInput($event)" />
              <ng-container *ngIf="createJobForm.get('custom_job_role_category')?.touched">
                <div class="text-danger smaller-text">
                  <small *ngIf="createJobForm.get('custom_job_role_category')?.errors?.['required']">
                    Custom category is required.
                  </small>
                  <small
                    *ngIf="createJobForm.get('custom_job_role_category')?.errors?.['minlength'] || createJobForm.get('custom_job_role_category')?.errors?.['maxlength']">
                    Category must be between 2 and 30 characters.
                  </small>
                  <small *ngIf="createJobForm.get('custom_job_role_category')?.errors?.['pattern']">
                    Only alphabets are allowed.
                  </small>
                </div>
              </ng-container>
            </div>
          </div>
        </div>

        <div class="form-input-control full-width-row">
          <label class="input-lbl-tag">Job Type</label>
          <div class="custom-radio-row-group">
            <label class="radio-inline-option">
              <input type="radio" name="jobType" value="Full-Time" formControlName="job_type" />
              <span class="radio-check-circle"></span>
              Full-Time
            </label>
            <label class="radio-inline-option">
              <input type="radio" name="jobType" value="Part-Time" formControlName="job_type" />
              <span class="radio-check-circle"></span>
              Part-Time
            </label>
            <label class="radio-inline-option">
              <input type="radio" name="jobType" value="Internship/Training" formControlName="job_type" />
              <span class="radio-check-circle"></span>
              Internship
            </label>
            <label class="radio-inline-option">
              <input type="radio" name="jobType" value="Contract" formControlName="job_type" />
              <span class="radio-check-circle"></span>
              Contract
            </label>
          </div>
        </div>

        <div class="form-row-2col animate-fade-in" *ngIf="
            createJobForm.value.job_type === 'Internship/Training' ||
            createJobForm.value.job_type === 'Contract'
          ">
          <div style="display: flex; gap: 1.5rem; width: 100%">
            <div class="form-input-control" style="flex: 1">
              <label class="input-lbl-tag">Duration</label>
              <input type="text" placeholder="e.g. 6" formControlName="duration" (input)="onDurationInput($event)"
                class="standard-input-element" />
            </div>
            <div class="form-input-control" style="flex: 1">
              <label class="input-lbl-tag">Unit</label>
              <div class="select-relative-wrapper">
                <select formControlName="duration_unit" class="standard-select-element">
                  <option value="Days">Days</option>
                  <option value="Weeks">Weeks</option>
                  <option value="Months">Months</option>
                </select>
              </div>
            </div>
          </div>
          <div></div>
        </div>

        <div class="form-row-2col">
          <div class="form-input-control">
            <label class="input-lbl-tag">Work Mode</label>
            <div class="custom-radio-row-group">
              <label class="radio-inline-option">
                <input type="radio" name="workMode" value="Onsite" formControlName="work_mode" />
                <span class="radio-check-circle"></span>
                Onsite
              </label>
              <label class="radio-inline-option">
                <input type="radio" name="workMode" value="Remote" formControlName="work_mode" />
                <span class="radio-check-circle"></span>
                Remote
              </label>
              <label class="radio-inline-option">
                <input type="radio" name="workMode" value="Hybrid" formControlName="work_mode" />
                <span class="radio-check-circle"></span>
                Hybrid
              </label>
            </div>
          </div>

          <div class="form-input-control animate-fade-in">
            <label class="input-lbl-tag">
              {{
              createJobForm.value.work_mode === "Remote"
              ? "Office Location *"
              : "Locations *"
              }}
            </label>
            <div style="
                display: flex;
                flex-direction: column;
                gap: 1rem;
                margin-bottom: 0.5rem;
              ">
              <div formArrayName="locations">
                <div *ngFor="let loc of locationsFA.controls; let i = index" style="
                    display: flex;
                    flex-direction: column;
                    gap: 0.25rem;
                    margin-bottom: 0.75rem;
                  ">
                  <div style="display: flex; align-items: center; gap: 0.75rem">
                    <div style="position: relative; flex: 1">
                      <input type="text" placeholder="e.g. Mumbai, India" [formControlName]="i"
                        class="standard-input-element" [class.has-error]="loc.touched && loc.invalid"
                        (input)="onJobLocationInput($event, i)" (focus)="onJobLocationFocus($event, i)"
                        (blur)="onJobLocationBlur(i)" />
                      <div class="suggestions-dropdown" *ngIf="
                          activeLocationIndex === i &&
                          showJobLocationsDropdown &&
                          filteredJobLocations.length
                        ">
                        <div class="suggestion-item" *ngFor="let loc of filteredJobLocations"
                          (mousedown)="selectJobLocation(loc, i)">
                          {{ loc }}
                        </div>
                      </div>
                    </div>
                    <button type="button" class="remove-location-btn" (click)="removeLocation(i)" style="
                        background: none;
                        border: none;
                        cursor: pointer;
                        color: #64748b;
                        font-size: 1.25rem;
                        padding: 0.25rem 0.5rem;
                        transition: color 0.2s;
                      " onmouseover="this.style.color = '#EF4444'" onmouseout="this.style.color = '#64748B'">
                      ×
                    </button>
                  </div>
                  <div class="error-message" *ngIf="loc.touched && loc.invalid" style="
                      color: #dc2626;
                      font-size: 12px;
                      display: flex;
                      flex-direction: column;
                      gap: 2px;
                    ">
                    <ng-container *ngIf="loc.errors?.['required']">
                      <div>Location is required.</div>
                    </ng-container>
                    <ng-container *ngIf="loc.errors?.['multipleLocations']">
                      <div>Please enter a single location.</div>
                    </ng-container>
                    <ng-container *ngIf="loc.errors?.['invalidLocation']">
                      <div>
                        Please select a valid location from the suggestions.
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <button type="button" class="btn-add-location-flat" (click)="addLocation()">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                class="plus-icon">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              Add Location
            </button>
          </div>
        </div>
      </div>

      <!-- Card 2: Job Description -->
      <div class="form-block-card">
        <h3 class="card-section-heading">Job Description *</h3>
        <div class="form-vertical-layout">
          <div class="form-input-control">
            <label class="input-lbl-tag">Detailed Job Description</label>
            <div class="textarea-relative-wrapper">
              <textarea placeholder="Describe the job role..." formControlName="description" rows="4"
                class="standard-textarea-element"></textarea>

              <ng-container *ngIf="createJobForm.get('description') as description">
                <small class="text-danger smaller-text">
                  {{
                  description.touched
                  ? JobDescriptionsValidationUtils.getJobDescriptionError(
                  description
                  )
                  : ""
                  }}
                </small>
                <small class="text-muted">
                  {{
                  JobDescriptionsValidationUtils.getNonWhitespaceLength(
                  description.value
                  )
                  }}
                  / 5000
                </small>

                <small class="text-danger smaller-text" *ngIf="
                    JobDescriptionsValidationUtils.getNonWhitespaceLength(
                      description.value
                    ) >= 5000
                  ">
                  5000 limit reached
                </small>
              </ng-container>

              <span class="textarea-resize-icon">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 0L0 10H10V0Z" fill="#94A3B8" />
                </svg>
              </span>
            </div>
          </div>

          <div class="form-input-control">
            <label class="input-lbl-tag">Roles & Responsibilities *</label>
            <div class="textarea-relative-wrapper">
              <textarea placeholder="List responsibilities..." formControlName="roles_and_responsibilities" rows="4"
                class="standard-textarea-element"></textarea>
              <small class="text-danger smaller-text" *ngIf="createJobForm.get('roles_and_responsibilities') as rr">
                {{
                rr.touched || rr.dirty
                ? JobRolesResponsibilitiesValidationUtils.getRolesResponsibilitiesError(
                rr
                )
                : ""
                }}
              </small>

              <small class="text-muted" *ngIf="createJobForm.get('roles_and_responsibilities') as rr">
                {{
                JobRolesResponsibilitiesValidationUtils.getNonWhitespaceLength(
                rr.value
                )
                }}
                / 3000
              </small>

              <small class="text-danger smaller-text" *ngIf="createJobForm.get('roles_and_responsibilities') as rr">
                <ng-container *ngIf="
                    JobRolesResponsibilitiesValidationUtils.getNonWhitespaceLength(
                      rr.value
                    ) >= 3000
                  ">
                  3000 limit reached
                </ng-container>
              </small>
              <span class="textarea-resize-icon">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 0L0 10H10V0Z" fill="#94A3B8" />
                </svg>
              </span>
            </div>
          </div>

          <div class="form-input-control">
            <label class="input-lbl-tag">Required Skills *</label>
            <div class="skills-input-group-container">
              <input type="text" placeholder="Add skill" formControlName="newRequiredSkill"
                (keyup.enter)="addRequiredSkill()" class="standard-input-element" />
              <button class="add-skill-action-btn ms-3" type="button" (click)="addRequiredSkill()">
                Add
              </button>
            </div>
            <ng-container *ngIf="createJobForm.get('newRequiredSkill') as newSkillCtrl">
              <div class="error-message" *ngIf="newSkillCtrl.touched && newSkillCtrl.invalid"
                style="color: #dc2626; font-size: 12px; margin-top: 4px">
                <span *ngIf="newSkillCtrl.errors?.['multipleSkills']">
                  Please enter a single skill at a time.
                </span>
              </div>
            </ng-container>
            <ng-container *ngIf="createJobForm.get('required_skills') as skillsControl">
              <small class="text-danger smaller-text">
                {{
                JobRequiredSkillValidationUtils.getRequiredSkillsError(
                skillsControl
                )
                }}
              </small>
            </ng-container>
            <div class="skills-capsule-badges-row mt-2">
              <span class="skill-pill-item" *ngFor="let skill of requiredSkillsList">
                {{ skill }}
                <button type="button" class="remove-pill-btn" (click)="removeRequiredSkill(skill)">
                  ×
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Card 3: Eligibility & Compensation -->
      <div class="form-block-card">
        <h3 class="card-section-heading">Eligibility & Compensation</h3>
        <div class="form-vertical-layout">
          <!-- Education Badge Matrix -->
          <div class="form-input-control width-full">
            <label class="input-lbl-tag">Education</label>
            <div class="matrix-pill-badge-grid">
              <button type="button" class="matrix-pill-btn" *ngFor="let edu of educationOptions"
                [class.selected]="selectedEducation.includes(edu)" (click)="toggleEducation(edu)">
                {{ edu }}
              </button>
            </div>
          </div>

          <!-- Inputs Row Grid -->
          <div class="form-row-3col">
            <div class="form-input-control">
              <label class="input-lbl-tag">Minimum CGPA</label>
              <input type="text" placeholder="e.g. 6.5" formControlName="min_cgpa" (input)="onCgpaInput($event)"
                class="standard-input-element" />
              <small class="text-danger smaller-text">
                {{
                CGPAValidationUtils.getCgpaError(
                createJobForm.get("min_cgpa")
                )
                }}
              </small>
            </div>

            <div class="form-input-control">
              <label class="input-lbl-tag">Experience Level</label>
              <div class="select-relative-wrapper">
                <select formControlName="experience_level" class="standard-select-element">
                  <option value="" disabled selected>Select</option>
                  <option *ngFor="let exp of experienceLevels" [value]="exp">
                    {{ exp }}
                  </option>
                </select>
              </div>
            </div>

            <!-- Year of passing badges -->
            <div class="form-input-control">
              <label class="input-lbl-tag">Year of Passing</label>
              <div class="mini-badges-row-wrap">
                <button type="button" class="matrix-pill-btn btn-sm" *ngFor="let yr of yearOfPassingOptions"
                  [class.selected]="selectedYears.includes(yr)" (click)="toggleYear(yr)">
                  {{ yr }}
                </button>
              </div>
            </div>
          </div>

          <!-- Salary, Expected Full-Time Salary and Openings (Conditional Layout) -->
          <div class="form-row-2col">
            <div class="form-input-control">
              <label class="input-lbl-tag">Salary / Stipend</label>
              <div style="display: flex; gap: 6px; align-items: center;">
                <select formControlName="currency" class="standard-input-element" style="width: auto;">
                  <option value="₹">₹ (INR)</option>
                  <option value="$">$ (USD)</option>
                  <option value="€">€ (EUR)</option>
                  <option value="£">£ (GBP)</option>
                </select>
                <input type="text" placeholder="Min" formControlName="salary_min"
                  (input)="onSalaryInput($event, 'salary_min')" class="standard-input-element" style="flex: 1; min-width: 0;" />
                <span class="font-bold text-sm text-gray-500 px-1">TO</span>
                <input type="text" placeholder="Max" formControlName="salary_max"
                  (input)="onSalaryInput($event, 'salary_max')" class="standard-input-element" style="flex: 1; min-width: 0;" />
                <select formControlName="payment_frequency" class="standard-input-element" style="width: auto;">
                  <option value="LPA">LPA</option>
                  <option value="Per Year">Per Year</option>
                  <option value="Per Month">Per Month</option>
                  <option value="Per Hour">Per Hour</option>
                </select>
              </div>
              <small class="text-danger smaller-text">
                {{
                SalaryValidationUtils.getSalaryError(
                createJobForm.get("salary_min")
                )
                }}
              </small>
            </div>

            <!-- DYNAMIC FIELD FOR INTERNSHIP -->
            <div class="form-input-control animate-fade-in"
              *ngIf="createJobForm.value.job_type === 'Internship/Training'">
              <label class="input-lbl-tag">Expected Full-Time Salary</label>
              <div style="display: flex; gap: 6px; align-items: center;">
                <select formControlName="expected_full_time_salary_currency" class="standard-input-element" style="width: auto;">
                  <option value="₹">₹ (INR)</option>
                  <option value="$">$ (USD)</option>
                  <option value="€">€ (EUR)</option>
                  <option value="£">£ (GBP)</option>
                </select>
                <input type="text" placeholder="e.g. 5 or 500000" formControlName="expected_full_time_salary"
                  (input)="onSalaryInput($event, 'expected_full_time_salary')" class="standard-input-element" style="flex: 1; min-width: 0;" />
                <select formControlName="expected_full_time_salary_frequency" class="standard-input-element" style="width: auto;">
                  <option value="LPA">LPA</option>
                  <option value="Per Year">Per Year</option>
                  <option value="Per Month">Per Month</option>
                  <option value="Per Hour">Per Hour</option>
                </select>
              </div>
            </div>

            <div class="form-input-control">
              <label class="input-lbl-tag">Number of Openings</label>
              <input type="text" placeholder="e.g. 5" formControlName="number_of_openings"
                (input)="onOpeningsInput($event)" class="standard-input-element" />
              <small class="text-danger smaller-text">
                {{
                OpeningsValidationUtils.getOpeningsError(
                createJobForm.get("number_of_openings")
                )
                }}
              </small>
            </div>
          </div>

          <!-- Extra details line 4 -->
          <div class="side-by-side-layout">
            <div class="form-input-control">
              <label class="input-lbl-tag">Default Passing Score (%)</label>
              <input type="number" placeholder="e.g. 40" formControlName="default_passing_score"
                class="standard-input-element" />
              <div class="error-message" *ngIf="createJobForm.get('default_passing_score')?.touched && createJobForm.get('default_passing_score')?.invalid" style="color: #dc2626; font-size: 12px; margin-top: 4px">
                <span *ngIf="createJobForm.get('default_passing_score')?.errors?.['required']">Passing score is required.</span>
                <span *ngIf="createJobForm.get('default_passing_score')?.errors?.['min']">Score cannot be less than 1.</span>
                <span *ngIf="createJobForm.get('default_passing_score')?.errors?.['max']">Score cannot exceed 100.</span>
              </div>
            </div>
            
            <!-- Placeholder to balance the flex layout -->
            <div class="form-input-control"></div>
          </div>

          <!-- Perks badge matrix -->
          <div class="form-input-control width-full">
            <label class="input-lbl-tag">Perks & Benefits</label>
            <div class="matrix-pill-badge-grid">
              <button type="button" class="matrix-pill-btn" *ngFor="let perk of perksOptions"
                [class.selected]="selectedPerks.includes(perk)" (click)="togglePerk(perk)">
                {{ perk }}
              </button>
            </div>
          </div>

          <div class="form-input-control width-full">
            <label class="input-lbl-tag">Application Deadline</label>
            <div class="datepicker-icon-input-wrapper">
              <span class="calendar-icon-indicator">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
              </span>
              <input type="date" placeholder="Pick a date" [min]="todayDate" formControlName="application_deadline"
                class="standard-datepicker-element" [class.has-error]="
                  createJobForm.get('application_deadline')?.touched &&
                  createJobForm.get('application_deadline')?.invalid
                " />
            </div>
            <div class="error-message" *ngIf="
                createJobForm.get('application_deadline')?.touched &&
                createJobForm.get('application_deadline')?.invalid
              " style="color: #dc2626; font-size: 12px; margin-top: 4px">
              <span *ngIf="
                  createJobForm.get('application_deadline')?.errors?.[
                    'pastDate'
                  ]
                ">Application deadline cannot be in the past.</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Back and Continue action bar -->
      <div class="bottom-action-buttons-row">
        <button class="btn-cancel-flat" (click)="navigateToJobsTab()" type="button">
          Back
        </button>
        <button class="btn-brand-continue" [class.btn-disabled-state]="createJobForm.invalid"
          [attr.aria-disabled]="createJobForm.invalid" (click)="nextStep()" type="button">
          Continue
        </button>
      </div>
    </div>

    <!-- STEP 2: REVIEW & SUBMIT VIEW -->
    <div class="step-content-panel fade-in-panel" *ngIf="currentStep === 2">
      <!-- Card 1: Review details grid -->
      <div class="form-block-card shadow-premium-sm">
        <h3 class="card-section-heading">Review Your Job Posting</h3>

        <div class="review-details-flex-grid-v2">
          <div class="review-item-v2">
            <span class="review-lbl-v2">Job Title</span>
            <span class="review-val-v2">
              {{ createJobForm.get("job_title")?.value }}
            </span>
          </div>
          <div class="review-item-v2">
            <span class="review-lbl-v2">Category</span>
            <span class="review-val-v2">
              {{ createJobForm.get("job_role_category")?.value }}
            </span>
          </div>
          <div class="review-item-v2">
            <span class="review-lbl-v2">Type</span>
            <span class="review-val-v2 highlight-value-text">
              {{ createJobForm.get("job_type")?.value }}
            </span>
          </div>
          <div class="review-item-v2" *ngIf="
              createJobForm.get('job_type')?.value === 'Internship/Training' ||
              createJobForm.get('job_type')?.value === 'Contract'
            ">
            <span class="review-lbl-v2">Duration</span>
            <span class="review-val-v2">
              {{
              createJobForm.value.duration
              ? createJobForm.value.duration +
              " " +
              createJobForm.value.duration_unit
              : "—"
              }}
            </span>
          </div>
          <div class="review-item-v2">
            <span class="review-lbl-v2">Work Mode</span>
            <span class="review-val-v2 highlight-value-text">
              {{ createJobForm.value.work_mode || "—" }}
            </span>
          </div>
          <div class="review-item-v2">
            <span class="review-lbl-v2">
              {{
              createJobForm.value.work_mode === "Remote"
              ? "Office Location"
              : "Locations"
              }}
            </span>
            <span class="review-val-v2">{{ locationsDisplay }} </span>
          </div>
          <div class="review-item-v2">
            <span class="review-lbl-v2">Experience</span>
            <span class="review-val-v2">
              {{ createJobForm.value.experience_level || "—" }}
            </span>
          </div>
          <div class="review-item-v2">
            <span class="review-lbl-v2">Salary / Stipend</span>
            <span class="review-val-v2">
              {{ createJobForm.value.salary_min ? formatReviewSalary(createJobForm.value.salary_min, createJobForm.value.currency, createJobForm.value.payment_frequency) : '—' }}
              <ng-container *ngIf="createJobForm.value.salary_max && createJobForm.value.salary_max !== createJobForm.value.salary_min">
                - {{ formatReviewSalary(createJobForm.value.salary_max, createJobForm.value.currency, createJobForm.value.payment_frequency) }}
              </ng-container>
            </span>
          </div>
          <div class="review-item-v2" *ngIf="createJobForm.value.job_type === 'Internship/Training'">
            <span class="review-lbl-v2">Expected Full-Time Salary</span>
            <span class="review-val-v2">
              {{ formatReviewSalary(createJobForm.value.expected_full_time_salary, createJobForm.value.expected_full_time_salary_currency, createJobForm.value.expected_full_time_salary_frequency) }}
            </span>
          </div>
          <div class="review-item-v2">
            <span class="review-lbl-v2">Openings</span>
            <span class="review-val-v2">
              {{ createJobForm.value.number_of_openings || "—" }}
            </span>
          </div>
          <div class="review-item-v2">
            <span class="review-lbl-v2">Deadline</span>
            <span class="review-val-v2 deadline-accent-value">
              {{ createJobForm.value.application_deadline || "—" }}
            </span>
          </div>

          <div class="review-item-v2 full-width-review">
            <span class="review-lbl-v2">Required Skills</span>
            <span class="review-val-v2">
              {{
              requiredSkillsList.length ? requiredSkillsList.join(", ") : "—"
              }}
            </span>
          </div>

          <div class="review-item-v2">
            <span class="review-lbl-v2">Education</span>
            <span class="review-val-v2">
              {{
              selectedEducation.length ? selectedEducation.join(", ") : "—"
              }}
            </span>
          </div>

          <div class="review-item-v2">
            <span class="review-lbl-v2">Minimum CGPA</span>
            <span class="review-val-v2">
              {{ createJobForm.value.min_cgpa || "—" }}
            </span>
          </div>

          <div class="review-item-v2">
            <span class="review-lbl-v2">Year of Passing</span>
            <span class="review-val-v2">
              {{ selectedYears.length ? selectedYears.join(", ") : "—" }}
            </span>
          </div>

          <div class="review-item-v2 full-width-review">
            <span class="review-lbl-v2">Perks & Benefits</span>
            <span class="review-val-v2">
              {{ selectedPerks.length ? selectedPerks.join(", ") : "—" }}
            </span>
          </div>
        </div>
      </div>

      <!-- will be using this later
      <div class="form-block-card">
        <div class="visibility-flex-row">
          <div class="visibility-text-block">
            <h3 class="card-section-heading">Student Dashboard Visibility</h3>
            <p class="section-instruction-subtitle">
              When turned on, this job will be visible on the BeExpert student
              dashboard so students can discover and apply.
            </p>
          </div>

          <div class="visibility-toggle-row">
            <span
              class="status-badge"
              [ngClass]="
                createJobForm.get('is_visible_on_student_dashboard')?.value
                  ? 'badge-green'
                  : 'badge-red'
              "
            >
              {{
                createJobForm.get("is_visible_on_student_dashboard")?.value
                  ? "Visible"
                  : "Not Visible"
              }}
            </span>

            <label class="switch">
              <input
                type="checkbox"
                formControlName="is_visible_on_student_dashboard"
              />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div> -->
      <!-- Card 2: Screening Method Selection -->
      <div class="form-block-card lavender-block-border shadow-premium-sm">
        <h3 class="card-section-heading">Screening by BeExpert</h3>
        <p class="section-instruction-subtitle">
          Choose how BeExpert should screen applicants for this role. You'll
          receive detailed candidate reports after each selected round.
        </p>

        <div class="screening-mode-cards-row">
          <!-- Option 1: Assessment only -->
          <div class="screening-option-card" [class.active-mode]="
              selectedScreeningMethod === JOB_SCREENING_METHOD.ASSESSMENT_ONLY
            " (click)="setScreeningMethod(JOB_SCREENING_METHOD.ASSESSMENT_ONLY)">
            <div class="mode-header-row">
              <span class="mode-card-icon purple-text">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
              </span>
              <div class="mode-text-meta">
                <h4 class="mode-title-heading">Assessment only</h4>
                <p class="mode-desc-text">Aptitude & technical assessment</p>
              </div>
            </div>
          </div>

          <!-- Option 2: AI Interview only -->
          <div class="screening-option-card" [class.active-mode]="
              selectedScreeningMethod === JOB_SCREENING_METHOD.AI_INTERVIEW_ONLY
            " (click)="setScreeningMethod(JOB_SCREENING_METHOD.AI_INTERVIEW_ONLY)">
            <div class="mode-header-row">
              <span class="mode-card-icon orange-text">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                </svg>
              </span>
              <div class="mode-text-meta">
                <h4 class="mode-title-heading">AI Interview only</h4>
                <p class="mode-desc-text">
                  Automated interview with AI summary
                </p>
              </div>
            </div>
          </div>

          <!-- Option 3: Assessment + AI Interview -->
          <div class="screening-option-card" [class.active-mode]="
              selectedScreeningMethod ===
              JOB_SCREENING_METHOD.ASSESSMENT_AND_AI_INTERVIEW
            " (click)="
              setScreeningMethod(
                JOB_SCREENING_METHOD.ASSESSMENT_AND_AI_INTERVIEW
              )
            ">
            <div class="mode-header-row">
              <span class="mode-card-icon blue-text">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                  <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
              </span>
              <div class="mode-text-meta">
                <h4 class="mode-title-heading">Assessment + AI Interview</h4>
                <p class="mode-desc-text">Full screening pipeline</p>
              </div>
            </div>
          </div>
        </div>

        <div class="selected-method-label-row">
          <span>Selected:
            <strong class="highlight-text">{{
              getScreeningMethodLabel(selectedScreeningMethod)
              }}</strong></span>
        </div>

        <!-- Hiring Process Preview Card -->
        <div class="hiring-process-card">
          <div class="process-header">
            <span class="process-icon">
              <i class="bi bi-stars"></i>
            </span>
            <h4>AI Hiring Process</h4>
          </div>

          <p class="process-description">
            Candidates shortlisted through this process are evaluated across
            {{ hiringProcessSteps.length }} stages. Students who clear the
            selected rounds will be shortlisted for recruiter review.
          </p>

          <div class="process-step" *ngFor="let step of hiringProcessSteps; let i = index">
            <strong>Stage {{ i + 1 }}:</strong>
            {{ step }}
          </div>
        </div>
      </div>

      <!-- Back and Submit action bar -->
      <div class="bottom-action-buttons-row">
        <button class="btn-cancel-flat" (click)="prevStep()" type="button">
          Back
        </button>
        <div class="d-flex gap-3">
          <button class="btn-brand-continue btn-submit-job" type="button" (click)="submitDraftJob()"
            [disabled]="createJobForm.invalid || isDraftLoading">
            <ng-container *ngIf="isDraftLoading; else noDraftLoading">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span> Saving...</span></ng-container>
            <ng-template #noDraftLoading>
              <span> Save as Draft</span></ng-template>
          </button>
          <button class="btn-brand-continue btn-submit-job" type="button" (click)="submitJob()"
            [disabled]="createJobForm.invalid || isLoading">
            <ng-container *ngIf="isLoading; else noLoading">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span> Saving...</span></ng-container>
            <ng-template #noLoading> <span> Submit Job</span></ng-template>
          </button>
        </div>
      </div>
    </div>

    <!-- STEP 3: SUCCESS STATE VIEW -->
    <div class="success-screen-panel fade-in-panel" *ngIf="currentStep === 3">
      <div class="success-state-container-card">
        <div class="success-icon-badge">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        <h2 class="success-title">Job Submitted Successfully</h2>
        <p class="success-subtitle-desc">
          Your job posting is pending approval. It will be live once reviewed by
          the admin.
        </p>

        <span class="pending-approval-badge">Pending Approval</span>

        <button class="btn-view-all-jobs" (click)="navigateToJobsTab()" type="button">
          View All Jobs
        </button>
      </div>
    </div>
  </form>
</div>